<div class="container-right-main fluid-container">
  <div *ngIf="!hasEvaluations" class="no-data">
    <p>No evaluation data available for this feedback.</p>
  </div>
  <mat-tab-group *ngIf="hasEvaluations" [(selectedIndex)]="selectedIndex">
    <mat-tab *ngFor="let tab of tabs; index as i">
      <ng-template mat-tab-label>
        <span>
          {{ tab.label }}
          <button mat-icon-button [matTooltip]="tabDescriptions[tab.label]?.description || ''"
            matTooltipPosition="above" aria-label="Tab info" style="vertical-align: middle; margin-left: 4px;">
            <mat-icon>info</mat-icon>
          </button>
        </span>
      </ng-template>
      <div class="tab-content">
        <div *ngIf="tab.items?.length && tab.items[0]?.includes('Score:')" class="score">
          {{ tab.items[0] }}
        </div>
        <div class="description">
          <p>{{ tab.description }}</p>
        </div>
        <div *ngIf="tab.items?.length > 1 || (tab.items?.length === 1 && !tab.items[0]?.includes('Score:'))">
          <ul>
            <ng-container *ngFor="let item of tab.items">
              <li *ngIf="!item.includes('Score:')">
                {{ item }}
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>